import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=71fa6b6e"
import script from "./Gateways.vue?vue&type=script&lang=js"
export * from "./Gateways.vue?vue&type=script&lang=js"
import style0 from "./Gateways.vue?vue&type=style&index=0&id=71fa6b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports